define('app/filters/CompoundFilterView',['require','glu/itemView','./CompactFieldFilterView','./SegmentView','app/config/filterTypes','glu/dialog','app/app','glu/$','glu/util','hbs!./CompoundFilterView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		CompactFieldFilterView = require('./CompactFieldFilterView'),
		SegmentView = require('./SegmentView'),
		FILTER_TYPES = require('app/config/filterTypes'),
		dialog = require('glu/dialog'),
		App = require('app/app'),
		$ = require('glu/$'),
		_ = require('glu/util');


	var CompoundFilterView = ItemView.extend({
		compactFieldFilterView: CompactFieldFilterView,

		template: require('hbs!./CompoundFilterView.hbs'),
		events: {
			'change [name=operator]': 'updateModel'
		},

		initialize: function() {

			this.subViews = [];
			this.numFilters = -1;
			this.prevNumFilters = -1;

			var filterCollection = this.model.filterCollection();
			filterCollection.each(function(xFieldFilter) {
				if (xFieldFilter.fetchConstraints) {
					if (xFieldFilter.get('columnType') !== 'SEGMENT') {
						xFieldFilter.fetchConstraints();
					}
				}
			});
			this.listenTo(filterCollection, 'add remove', this.render);
		},

		serializeData: function() {
			return this;
		},
		operators: function() {
			var selectedOperator = this.model.getOperator();

			return _.map(FILTER_TYPES.compound, function(o) {
				return {
					label: o.label,
					value: o.operator,
					isSelected: o.operator === selectedOperator
				};
			});
		},
		updateModel: function() {
			this.model.setOperator(this.$el.find('[name=operator]').val());
		},

		onRender: function() {
			var self = this;

			this.prevNumFilters = this.numFilters;
			this.numFilters = this.model.filterCollection().length;

			self.addSegments();
			self.addFunctions();
			self.addFilters();
		},

		addFilters: function() {
			var self = this,
				filtersList = this.$el.find('.compound-filters-list'),
				subViews = this.subViews,
				numDialogs = $('.modal-dialog').length;

			this.model.filterCollection().each(function(filter) {
				if ((!filter.get('segmentId') && !filter.get('function')) || (filter.get('segmentId') && filter.get('values') && (filter.get('values')[0] === 'true' || filter.get('values')[0] === 'false'))) {

					filter.set('segmentId', undefined);

					var FilterView = filter.isCompound() ? CompoundFilterView : self.compactFieldFilterView;
					var view = new FilterView({
						model: filter,
						report: self.options.report,
						tagName: 'li',
						className: 'form-group filter-compact'
					});

					view.render();
					filtersList.append(view.render().$el);
					subViews.push(view);

					// We only want 1 dialog to open, and only if a filter has been added (not removed)
					if (!filter.isValid() && numDialogs === 0 && self.numFilters > self.prevNumFilters) {
						view.openEditFilterDialog();
						numDialogs++;
					}
				}
			});
		},

		addSegments: function() {
			var self = this,
				segmentList = this.$el.find('.segment-list'),
				subViews = this.subViews,
				uniqueSegments = [],
				hasError;

			// Make sure there are no duplicates
			this.model.filterCollection().each(function(filter) {
				if (filter.get('segmentId') && !(filter.get('values') && (filter.get('values')[0] === 'true' || filter.get('values')[0] === 'false'))) {
					if (uniqueSegments.indexOf(filter.get('segmentId')) === -1) {
						uniqueSegments.push(filter.get('segmentId'));
					}
				}
			});

			self.options.report.set('segments', uniqueSegments, {
				silent: true
			});

			for (var i = 0; i < uniqueSegments.length; i++) {
				var segment = App.segments.get(uniqueSegments[i]);

				if (segment) {
					var view = new SegmentView({
						model: segment,
						report: self.options.report,
						tagName: 'li',
						className: 'form-group segment'
					});

					view.render();
					segmentList.append(view.render().$el);
					subViews.push(view);
				} else {
					if (!hasError) {
						dialog.error('This report contains segments which we were not able to load, so we have removed them.', 'There was a problem loading this report');
						hasError = true;
					}
				}
			}
		},

		addFunctions: function() {

		},

		onClose: function() {

			_.each(this.subViews, function(view) {
				view.close();
			});
		}

	});

	return CompoundFilterView;

});

